"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6809],{

/***/ 46809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_util_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44269);






var BlockRender = function(param) {
    var block = param.block, amount = param.amount;
    var ref, ref1, ref2, ref3, ref4;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().push;
    var ref5, ref6, ref7, ref8, ref9;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: function(e) {
            var ref;
            return (block === null || block === void 0 ? void 0 : block.wholeClick) ? push((ref5 = block === null || block === void 0 ? void 0 : (ref = block.cta) === null || ref === void 0 ? void 0 : ref.ctaUrl) !== null && ref5 !== void 0 ? ref5 : "") : null;
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("flex w-full justify-center relative max-h-[25vh]", {
            "cursor-pointer": block === null || block === void 0 ? void 0 : block.wholeClick
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative md:h-[25vh] flex", {
                "aspect-video h-[unset] w-full 2xl:w-[unset]": amount > 1,
                "w-full h-[100px] md:h-[150px] xl:h-[200px]": amount === 1
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    passHref: true,
                    href: (ref6 = block === null || block === void 0 ? void 0 : (ref = block.cta) === null || ref === void 0 ? void 0 : ref.ctaUrl) !== null && ref6 !== void 0 ? ref6 : "",
                    prefetch: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            "z-20 absolute text-lg font-display subpixel-antialiased left-0 right-0 bottom-0 px-4 py-3 text-white backdrop-filter backdrop-blur-md backdrop-brightness-75 overflow-hidden": amount > 1,
                            "z-20 text-sm sm:text-md md:text-1xl lg:text-2xl xl:text-3xl 2xl:text-4xl mb-2 self-center text-right sm:text-center pr-10 sm:pr-0 w-full font-display subpixel-antialiased": amount === 1
                        }),
                        children: (ref7 = block === null || block === void 0 ? void 0 : (ref1 = block.cta) === null || ref1 === void 0 ? void 0 : ref1.ctaText) !== null && ref7 !== void 0 ? ref7 : ""
                    })
                }),
                (block === null || block === void 0 ? void 0 : (ref2 = block.image) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    loader: _lib_util_loader__WEBPACK_IMPORTED_MODULE_5__/* .ImageLoader */ .S,
                    src: (ref8 = block === null || block === void 0 ? void 0 : (ref3 = block.image) === null || ref3 === void 0 ? void 0 : ref3.url) !== null && ref8 !== void 0 ? ref8 : "",
                    layout: "fill",
                    objectFit: amount > 1 ? "cover" : "contain",
                    alt: (ref9 = block === null || block === void 0 ? void 0 : (ref4 = block.image) === null || ref4 === void 0 ? void 0 : ref4.alternativeText) !== null && ref9 !== void 0 ? ref9 : "",
                    sizes: amount > 1 ? "(max-width: 384px) 100vw, (max-width: 500px) 100vw, (max-width: 640px) 100vw, 33vw" : "(max-width: 1920px) 100vw, 1920px"
                })
            ]
        })
    }, "".concat(block === null || block === void 0 ? void 0 : block.id, "-blockitem"));
};
/* harmony default export */ __webpack_exports__["default"] = (BlockRender);


/***/ })

}]);